import { reflect } from '@effector/reflect'

import * as model from './model'
import { GoogleLoginButton as View } from './view'

export const GoogleLoginButton = reflect({
    view: View,
    bind: {
        onSignin: model.googleLoginFx,
    },
})
